import { AvatarGenerator } from 'random-avatar-generator';

export const getAvatar = () => {
  const generator = new AvatarGenerator();

  const Avatar = generator.generateRandomAvatar();
  return Avatar;
};
